/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserDto } from '../../models/create-user-dto';
import { UserDto } from '../../models/user-dto';

export interface UserControllerCreate$Params {
  role: string;

/**
 * 워크스페이스 초대 토큰
 */
  inviteToken?: string;
      body: CreateUserDto
}

export function userControllerCreate(http: HttpClient, rootUrl: string, params: UserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerCreate.PATH, 'post');
  if (params) {
    rb.query('role', params.role, {});
    rb.query('inviteToken', params.inviteToken, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

userControllerCreate.PATH = '/api/user/signup';
